import { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AnnouncementBar from "./AnnouncementBar";

const Layout = ({ children }: { children: ReactNode }) => (
  <div className="min-h-screen flex flex-col">
    <div className="fixed top-0 left-0 right-0 z-50 flex flex-col">
      <AnnouncementBar />
      <Navbar />
    </div>
    <main className="flex-1 pt-[113px]">{children}</main>
    <Footer />
  </div>
);

export default Layout;
